export { CollectionDetailPage } from './view/collection-detail-page';
export { collectionDetailSagas } from './sagas';
export { default as collectionDetailReducer, getCollectionDetail } from './slice';
